export default __webpack_public_path__ + "static/media/bigsmiley.d6f60bac.svg";